export const CAMPAIGN_DAILY_LIMIT_MIN = 1;
export const CAMPAIGN_DAILY_LIMIT_MAX = 100;

/**
 * Validate a campaign's daily emails per domain against the deliverability cap.
 * @param value Input text or a stored numeric limit; empty and fractional values are invalid.
 * @returns Whether the value is a whole number from 1 through 100.
 */
export function isValidCampaignDailyLimit(value: string | number): boolean {
  const limit = Number(value);
  return /^[0-9]+$/.test(String(value)) && Number.isInteger(limit)
    && limit >= CAMPAIGN_DAILY_LIMIT_MIN && limit <= CAMPAIGN_DAILY_LIMIT_MAX;
}
